import Nav from 'react-bootstrap/Nav';
import Navbar from 'react-bootstrap/Navbar';
import Offcanvas from 'react-bootstrap/Offcanvas';
import './index.scss'
import React, { useState, useEffect } from 'react';
import Button from 'react-bootstrap/Button';
import Modal from 'react-bootstrap/Modal';
import { useLocation, useNavigate } from "react-router-dom";
import axios from "axios";
import Loader from "../../Components/Loader/Loader";
import { LIVE_URL } from "../../env";
import Notification from "../../Components/Notification/Notification";
import store from "../../redux/store";
import Spinner from "react-bootstrap/Spinner";
import packageJson from "../../../package.json";
import { Alert } from 'react-bootstrap';
import { log_firebase_event } from '../..';

function TopNavbar(Props) {

    const [notificationMessage, setNotificationMessage] = useState('');
    const [notificationType, setNotificationType] = useState('');
    const [notificationKey, setNotificationKey] = useState(0);
    let [Search, SetSearch] = useState(store.getState().ProductSaveFilter.data.keyword);
    let [ResultData, SetResultData] = useState([]);
    const location = useLocation();
    let [SpinnerLoading, SetSpinnerLoading] = useState(false)
    const [isFocused, setIsFocused] = useState(false);

    const [hasmaster, setHasmaster] = useState(false);

    const [matchAll, setMatchAll] = useState(false);

    const handleMatchChange = (e) => {
        setMatchAll(!matchAll);
        handleFocus();
    }


    // Function to handle onFocus event
    const handleFocus = () => {
        setIsFocused(true);
    };

    // Function to handle onBlur event
    const handleBlur = () => {
        setIsFocused(false);
        // SetSearch('')
    };

    function getPageTitle(location) {
        if (['/categorylisting'].includes(location.pathname)) {
            return 'The Handbook';
        } else if (['/productinfo'].includes(location.pathname)) {
            return 'Product Details';
        } else if (['/wishlistproducthistory'].includes(location.pathname)) {
            return 'Your Wishlist';
        } else if (['/wishlistsharedhistory'].includes(location.pathname)) {
            return 'Wishlist History';
        } else if (['/recentvisit'].includes(location.pathname)) {
            return 'Visit History';
        } else if (['/usermaster'].includes(location.pathname)) {
            return 'User Master';
        } else {
            return '';
        }
    }

    const pageTitle = getPageTitle(location);
    const showSearchInput = !['/categorylisting', '/wishlistsharedhistory', '/wishlistproducthistory', '/recentvisit', '/productinfo', '/forgetpassword', '/usermaster'].includes(location.pathname);
    const showUserTags = !['/forgetpassword'].includes(location.pathname);
    const showBackInput = !['/categorylisting', '/categoryproductlisting'].includes(location.pathname);
    let navigate = useNavigate();
    const [show, setShow] = useState(false);
    let [loader, setLoader] = useState(false)
    const handleClose = () => {
        setShow(false);
    }

    const handleLogOut = () => {
        setLoader(true)
        setShow(false);
        let logOutUrl = LIVE_URL + 'logout'
        let payload = {
            username: localStorage.getItem("emailaddress")
        }
        const headers = {
            'Content-Type': 'text/plain',
            'Authorization': localStorage.getItem("token"),
            'useraddress': localStorage.getItem("useraddress")
        };
        axios.post(logOutUrl, payload, { headers }).then((response) => {
            if (response.data.status) {
                log_firebase_event('loggedout', { user_name: localStorage.getItem('firstname') + ' ' + localStorage.getItem('lastname') })
                setLoader(false)
                setShow(false);
                localStorage.clear()
                navigate('/')
            } else {
                setLoader(false)
            }
        }).catch((err => {
            setLoader(false)
        }))
    }
    const handleSaveTopToWishList = () => {
        Props.SaveTop100StylesToWishlist();
    }
    const handleShow = () => setShow(true);
    const NavigateToHome = () => {
        navigate('/categorylisting')
    }
    const HandleChangePassword = () => {
        navigate('/changepassword')
    }
    const HandleUserMaster = () => {
        navigate('/usermaster')
    }
    const HandleVisitHistory = () => {
        navigate('/recentvisit')
    }
    const HandleLikedProducts = () => {
        navigate('/wishlistproducthistory')
    }
    const HandleWishlistShared = () => {
        navigate('/wishlistsharedhistory')
    }
    const GetAutoSuggestion = () => {
        if (Search === '' || Search === null) {
            setNotificationKey(notificationKey + 1); // Increment the key to show the new message
            setNotificationMessage('Please Enter Keyword For Search');
            setNotificationType('success');
        } else {
            SetSpinnerLoading(true)
            let SearchUrl = LIVE_URL + 'autoSuggest'
            let payload = {
                keyword: Search
            }
            axios.post(SearchUrl, payload).then((response) => {
                if (response.data.status) {
                    SetSpinnerLoading(false)
                    const resultData = response.data.data.map(item => {
                        const keyParts = item.key.split('#');
                        const source = keyParts[0];
                        const sourceKey = keyParts[1].split('.')[0];
                        return { ...item, source, sourceKey };
                    });
                    SetResultData(resultData);
                } else {
                    SetSpinnerLoading(false)
                    setNotificationKey(notificationKey + 1); // Increment the key to show the new message
                    setNotificationMessage(response.data.message);
                    SetResultData([]);
                }
            }).catch((err => {
                setLoader(false)
            }))
        }
    }

    const CheckSearchDetails = (data) => {
        handleBlur();
        Props.updateProductData(data, Search, matchAll ? 1 : 0);
        SetResultData([])
    }
    const ResetSearchData = () => {
        SetSearch('')
        Props.updateProductData([], 'Reset');
        SetResultData([])
    }

    const handleSelectImage = (e) => {
        Props.setShowFileBrowser(true);
        SetSearch('')
    }

    useEffect(() => {

        let useremaillength = localStorage.getItem("emailaddress").length;

        if (parseInt(localStorage.getItem('hasmaster')) === (useremaillength + 1010)) {
            setHasmaster(true);
        }
    }, []);

    return (
        <>
            <Loader status={loader} />
            {notificationMessage && (
                <Notification
                    message={notificationMessage}
                    type={notificationType}
                    duration={2000}
                    onClose={() => {
                        setNotificationMessage('');
                        setNotificationType('');
                    }}
                    key={notificationKey} // Pass down the key prop
                />
            )}
            {['xxl'].map((expand) => (
                <Navbar key={expand} expand={expand} className="custom-nav">
                    <>
                        <Navbar.Brand>
                            <div>
                                <div className='d-flex justify-content-between align-items-center' style={{ height: '65px' }}>
                                    <div className='' style={{ height: '65px', display: 'flex', flexDirection: 'row', justifyContent: 'center', alignItems: 'center' }}>
                                        {showSearchInput && (
                                            <img onClick={NavigateToHome} alt="logo"
                                                style={{ height: '40px', width: '40px', cursor: 'pointer', marginBottom: '10px' }}
                                                src={require('../../assets/images/TBH_Small.png')} />
                                        )}
                                        {showBackInput && (
                                            <div>
                                                <i
                                                    className='fa fa-arrow-left'
                                                    style={{ marginRight: '30px', cursor: 'pointer', fontSize: '30px', color: 'white' }}
                                                    onClick={() => navigate(-1)}
                                                ></i>
                                            </div>
                                        )}
                                        {!showSearchInput && (
                                            <div>
                                                <span onClick={NavigateToHome}
                                                    style={{ fontSize: '20px', cursor: 'pointer', marginRight: '5px', color: 'white' }}>
                                                    <b>{pageTitle}</b>
                                                </span>
                                                <span style={{ fontSize: '10px', color: 'white' }}>V {packageJson.version}</span>
                                            </div>
                                        )}
                                        <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
                                            {showSearchInput && (
                                                <div style={{ position: 'relative' }}>
                                                    <div style={{ display: 'flex', flexDirection: 'row', alignContent: 'center', justifyContent: 'center' }}>
                                                        <div>

                                                            <input
                                                                type="text"
                                                                onFocus={handleFocus}
                                                                onBlur={handleBlur}
                                                                className="seachInputClass"
                                                                placeholder="Search"
                                                                value={Search}
                                                                onKeyDown={(e) => {
                                                                    if (e.key === 'Space' || e.keyCode === 32) {
                                                                        GetAutoSuggestion();
                                                                    }
                                                                    if (e.key === "Enter") {
                                                                        CheckSearchDetails(0)
                                                                    }
                                                                }}
                                                                onChange={(e) => {
                                                                    SetSearch(e.target.value);
                                                                    if (e.target.value === '') {
                                                                        SetResultData([])
                                                                    }
                                                                }}

                                                            />


                                                            {ResultData.length > 0 && Search !== '' && (
                                                                <div className="search-results border" style={{ position: 'absolute', marginLeft: '10px' }}>
                                                                    {ResultData.map((data) => {
                                                                        return (
                                                                            <div key={data.source} onClick={() => {
                                                                                CheckSearchDetails(data)
                                                                            }}>
                                                                                <div className="search_result_class"
                                                                                >
                                                                                    <span>
                                                                                        <strong>{data.doc_count}</strong>
                                                                                        <span> matches found in </span><strong>{data.source}</strong>
                                                                                    </span>
                                                                                </div>
                                                                            </div>
                                                                        );
                                                                    })}
                                                                </div>
                                                            )}

                                                        </div>
                                                        <div style={{ position: 'absolute', right: '0', marginRight: '5px', alignItems: 'center', justifyContent: 'center', display: 'flex' }}>

                                                            {SpinnerLoading ? (

                                                                <Spinner animation="border" role="status" style={{ marginTop: '5px', width: '25px', height: '25px', color: 'blue' }}>
                                                                    <span className="visually-hidden">Loading...</span>
                                                                </Spinner>
                                                            ) : (
                                                                <>
                                                                    {Search === undefined || Search.length === 0 ? (
                                                                        <i className="fa fa-search"
                                                                            style={{ marginTop: '5px' }}
                                                                            onClick={() => {
                                                                                CheckSearchDetails(0)
                                                                            }}></i>
                                                                    ) : (
                                                                        <div style={{}}>
                                                                            <label style={{ fontSize: '14px', }}>Match All</label>
                                                                            <input
                                                                                style={{ marginLeft: '10px', marginRight: '10px' }}
                                                                                type='checkbox'
                                                                                onChange={handleMatchChange}
                                                                                value={matchAll}

                                                                            />
                                                                            <i className="fa fa-close" onClick={ResetSearchData}></i>
                                                                        </div>

                                                                    )}


                                                                    {/* <i className="fa fa-image"
                                                                        style={{ width: '40px', height: '40px', marginInline: '5px' }}
                                                                        onClick={handleSelectImage}
                                                                    ></i> */}
                                                                </>
                                                            )}</div>



                                                    </div>
                                                    <button type="submit" className="search-icon position-absolute"
                                                        style={{
                                                            right: '5px',
                                                            top: '2px',
                                                            border: 'unset',
                                                            background: 'unset',
                                                        }} onClick={() => {
                                                            GetAutoSuggestion()
                                                        }}>

                                                    </button>
                                                </div>
                                            )}
                                        </div>

                                    </div>
                                    {showUserTags && (
                                        !isFocused &&
                                        <div className='d-flex align-items-center'>
                                            <i className="fa fa-heart display_heart" style={{
                                                fontSize: '36px',
                                                color: 'whitesmoke',
                                                marginLeft: '20px',
                                                marginRight: '10px'
                                            }} onClick={HandleLikedProducts}></i>

                                            {location.pathname === '/categoryproductlisting' &&
                                                <i className={"fa fa-bookmark display_heart"} style={{
                                                    fontSize: '36px',
                                                    color: '#e65015',
                                                    marginLeft: '0px',
                                                    marginRight: '10px'
                                                }} onClick={handleSaveTopToWishList}  ></i>
                                            }
                                            <Navbar.Toggle style={{ float: 'right', zIndex: '999999999' }}
                                                className='display-toggle'
                                                aria-controls={`offcanvasNavbar-expand-${expand}`}>
                                                <i className="fa fa-user" style={{ fontSize: '36px', color: 'whitesmoke' }}></i>
                                            </Navbar.Toggle>
                                            <div className='display-toggle-1'>
                                                <div className="navbar">

                                                    <div className="navbar-menu">
                                                        <ul className="horizontal-list">
                                                            <li>
                                                                <a style={{ borderRadius: '30px', backgroundColor: '#b32319', color: 'white', fontWeight: '700', fontSize: '12px' }}
                                                                    href='https://in-handbook.brainbees.com/v2/' target='_blank' rel='noopener noreferrer'>
                                                                    Try Next THB

                                                                </a>
                                                            </li>
                                                            <li> <span className="nav-item" onClick={NavigateToHome}>
                                                                Home
                                                            </span></li>

                                                            {location.pathname === '/categoryproductlisting' &&
                                                                <li>
                                                                    <span className="nav-item save-top100" onClick={handleSaveTopToWishList}>    Save Top Styles
                                                                    </span>
                                                                </li>
                                                            }
                                                            <li> <span className="nav-item" onClick={HandleVisitHistory}>
                                                                Recent Visits
                                                            </span></li>
                                                            <li> <span className="nav-item" onClick={HandleLikedProducts}>
                                                                Your Wishlist
                                                            </span></li>
                                                            <li><span className="nav-item" onClick={HandleWishlistShared}>
                                                                Wishlist Share History
                                                            </span></li>
                                                            <li><span className="nav-item" onClick={HandleChangePassword}>
                                                                Change Password
                                                            </span></li>
                                                            {hasmaster &&
                                                                <li><span className="nav-item" onClick={HandleUserMaster}>
                                                                    User Master
                                                                </span></li>
                                                            }
                                                            <li> <span className="nav-item" onClick={handleShow}>
                                                                Logout
                                                            </span></li>

                                                        </ul>








                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    )}
                                </div>
                            </div>

                        </Navbar.Brand>

                        <Navbar.Offcanvas
                            id={`offcanvasNavbar-expand-${expand}`}
                            aria-labelledby={`offcanvasNavbarLabel-expand-${expand}`}
                            placement="end"
                        >
                            <Offcanvas.Header closeButton>
                                <div className="user_nav" style={{}}>
                                    <div className="pr-4 pt-1 pb-4">
                                    </div>
                                    <img style={{ height: '100px', width: '100px' }}
                                        src={require('../../assets/images/icon1.png')} alt='icon' />
                                    <strong
                                        style={{ textTransform: 'uppercase' }}>{localStorage.getItem('firstname') + '  ' + localStorage.getItem('lastname')}</strong>
                                    <span>{localStorage.getItem('emailaddress')}</span>
                                    <span>{localStorage.getItem('mobilenumber')}</span>
                                </div>
                            </Offcanvas.Header>
                            <Offcanvas.Body>
                                <Nav className="justify-content-end flex-grow-1 pe-3">
                                    {/* <span className='navItemsClass'>Save List</span>*/}
                                    <span className='navItemsClass' onClick={NavigateToHome}>Home</span>
                                    <span className='navItemsClass' onClick={HandleVisitHistory}>Recent Visits</span>
                                    <span className='navItemsClass' onClick={HandleLikedProducts}>Your Wishlist</span>
                                    <span className='navItemsClass' onClick={HandleWishlistShared}>Wishlist Shared History</span>
                                    {hasmaster &&
                                        <span className='navItemsClass' onClick={HandleUserMaster}>User Master</span>}
                                    {/* <span className='navItemsClass'>Allocate Filters</span>*/}
                                    <span className='navItemsClass'
                                        onClick={HandleChangePassword}>Change Password</span>
                                    <span className='navItemsClass' onClick={handleShow}>Log Out</span>
                                </Nav>
                                <div style={{ marginTop: '30%', textAlign: 'center' }}>
                                    <span>Version {packageJson.version}</span>
                                </div>
                            </Offcanvas.Body>
                        </Navbar.Offcanvas>
                    </>
                </Navbar>
            ))}
            {/* <div className='border'>
                {ResultData.map((data)=>{
                    return(
                        <div>
                            <div className='search_resert_class'>
                                <span>{data.doc_count} matches found in {data.source}</span>
                            </div>
                        </div>
                    )
                })}
            </div>*/}
            <Modal show={show} onHide={handleClose} style={{ zIndex: '99999999999999', marginTop: "100px" }}>
                <Modal.Header closeButton>
                    <Modal.Title>Log Out</Modal.Title>
                </Modal.Header>
                <Modal.Body>Are You Sure Want To Log Out?</Modal.Body>
                <Modal.Footer>
                    <Button variant="primary" onClick={handleLogOut}>
                        Log Out
                    </Button>
                    <Button variant="secondary" onClick={handleClose}>
                        Close
                    </Button>
                </Modal.Footer>
            </Modal>
        </>
    );
}

export default TopNavbar;